import React from 'react';
import { FaArrowLeft } from 'react-icons/lib/fa';


class FallbackDetails extends React.Component {
    goBack = () => {
        if(this.props.history.length==1)
            this.props.history.push("/")
        else
            this.props.history.goBack();
    }

    render() {
        return (
            <div className="fallback-page">
                <br />
                <span onClick={this.goBack} title='back' className='nwmCol backArr'>
                    <FaArrowLeft />
                </span>
                <div className="container page container_t">
                    <div className='col-md-12'>
                        <p className="head">
                            Fallback Rates
                        </p>
                        <br/>
                        <br/>
                        <p>In [late 2020] we released a new version of RealisedRate.com than allows you to see the estimated fallback spread adjustment between LIBOR and RFR that would apply using the standard 5 year median lookback methodology as set out by ISDA, but based on any specified calculation date.  Where a date in the future is selected then a combination of realised rates for the past and estimated rates for the future (using forward curves) are used to establish the daily basis between LIBOR and RFR, and calculate the 5 year median value.  The right-hand column of the tenor table shows the spread adjustment in basis points (‘bp’) followed by that adjustment value added to the compounded rate from the left of the table for the relevant tenor.</p>
                        <p>These values are presented for information purposes only to illustrate the expected spread adjustment between the old and the new rates when applying the standard calculation rules and using current market data, but should not be used in any contracts and do not form part of any offer to trade on the part of NatWest or any of its affiliates.</p>
                        <br/>
                        <br/>
                    </div>
                </div>
            </div>
        );
    }
}

//export default Home;
export default FallbackDetails;


// WEBPACK FOOTER //
// ./src/components/FallbackDetails.js